import React from 'react';
import '../styles/Vision.css';

const Vision = () => {
  return (
    <section className="vision-container">
      <div className="vision-content">
        <h2 className="vision-title">Our Vision</h2>
        <p className='vision-text'>
          To be the premier partner for businesses seeking to innovate and grow through the world's most advanced engineering and technology solutions.
        </p>
        {/* <p className="vision-text">
          To be the <span className="highlight">premier partner</span> for businesses seeking to{' '}
          <span className="highlight">innovate and grow</span> through the world's{' '}
          <span className="highlight">most advanced</span> engineering and technology solutions.
        </p> */}
      </div>
      <div className="vision-decoration"></div>
    </section>
  );
};

export default Vision;

